import { render, staticRenderFns } from "./tfasetup.vue?vue&type=template&id=8dc0cf76&scoped=true&"
import script from "./tfasetup.vue?vue&type=script&lang=tsx&"
export * from "./tfasetup.vue?vue&type=script&lang=tsx&"
import style0 from "./tfasetup.vue?vue&type=style&index=0&id=8dc0cf76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc0cf76",
  null
  
)

export default component.exports